import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLecturaComedero = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lectura_comedero',
        name: 'Lectura Comedero',
        component: ViewLecturaComedero,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router